<template>
  <div class="container-toggle">
    <span :class="$i18n.locale === 'pt-br' && 'selected'" @click="() => setLang('pt-br')">PT</span>
    <span class="separator">{{ "|" }}</span>
    <span :class="$i18n.locale === 'en' && 'selected'" @click="() => setLang('en')">EN</span>
  </div>
</template>

<script>
export default {
  props: [""],
  methods: {
    setLang(lang) {
      this.$emit("input", lang);
    },
  },
};
</script>

<style lang="scss">
.separator {
  margin: 0 15px;
}
.container-toggle {
  position: absolute;
  top: 50%;
  right: 30px;
  margin-top: -10px;
  display: block;
  cursor: pointer;
  span {
    color: #9e9b9c;
    font-size: 18px;
  }
  .selected {
    color: #fff;
  }
}
@media (max-width: 400px) {
  .separator {
    margin: 0 5px;
  }
  .container-toggle {
    position: absolute;
    top: 50%;
    right: 15px;
    margin-top: -9px;
    display: block;
    cursor: pointer;
    span {
      color: #9e9b9c;
      font-size: 15px;
    }
    .selected {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SwitchLocale.vue